import { useNavigate } from 'react-router-dom';
import { useAuth } from '../firebase/auth-context';

/** Not-authorized page — shown when a signed-in user lacks the admin claim. */
export default function NotAuthorized() {
  const { signOut, user } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate('/login', { replace: true });
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1>Not authorized</h1>
        <div className="auth-subtitle">
          {user
            ? `Signed in as ${user.email}, but this account does not have admin access.`
            : 'You do not have admin access.'}
        </div>
        <div className="alert alert-info" style={{ marginBottom: 16 }}>
          Admin access requires the <code>admin: true</code> custom claim on your
          Firebase Auth account. Contact a project owner to grant it.
        </div>
        <button type="button" className="btn btn-secondary" onClick={handleSignOut}>
          Sign out
        </button>
      </div>
    </div>
  );
}
